<template>
  <div class="w-full mb-20">
    <div>
      <div class="text-4xl text-center mb-20">
        Our <span class="text-orange-500">Team</span>
      </div>
    </div>
    <div>
      <div class="lg:flex gap-6 px-4">
        <ReactiveCard class="lg:w-1/2 mb-8 lg:mb-0">
          <div>
            <img
              :src="photos.vadim.src"
              :srcset="photos.vadim.srcset"
              :sizes="photoSizes"
              alt="Vadim"
              loading="lazy"
              decoding="async"
              width="250"
              height="250"
              class="w-1/2 aspect-square object-cover mx-auto border-2 rounded-full"
            />
            <div class="text-center text-3xl mt-4">Vadim Peter Hudolozhkin</div>
            <div class="text-center text-2xl">Engineer</div>
            <RadarChart v-if="false" />
            <div class="px-8 pt-4 text-center">
              Over the course of almost two decades, I've amassed extensive
              experience across both hardware and software domains. In a
              professional capacity, I've collaborated with diverse development
              organizations, ranging from burgeoning startups to established
              market leaders, within the sectors of Internet Service Provision,
              e-discovery, and trading systems in various financial markets. On a
              personal front, my portfolio comprises an array of tools for data
              analytics, algorithmic trading bots, and bespoke web applications
              geared towards reconnaissance and data intelligence. I comfortably
              work with a wide range of technologies, including Vue, JS, Node,
              Python, C#, C++, MongoDB, SQL, Linux, and many more.
            </div>
          </div>
        </ReactiveCard>
        
        <ReactiveCard class="lg:w-1/2">
          <div>
            <img
              :src="photos.david.src"
              :srcset="photos.david.srcset"
              :sizes="photoSizes"
              alt="David"
              loading="lazy"
              decoding="async"
              width="250"
              height="250"
              class="w-1/2 aspect-square object-cover mx-auto border-2 rounded-full"
            />
            <div class="text-center text-3xl mt-4">David Schiller</div>
            <div class="text-center text-2xl">Engineer</div>
            <div class="px-8 mt-4 text-center">
              Hi, I'm David Schiller, a Product Manager and Full Stack Developer
              with a deep-rooted love for engineering. My career spans across
              creating award-winning commercial videos to developing innovative
              web applications and physical products. Winning three Gold Telly
              Awards and working with dynamic teams at CollegeHumor, Wolfram
              Research, and UIUC's Public Affairs, I've blended creativity with
              technical expertise. In 2017, I founded Collider Cowork, a testament
              to my passion for building and collaboration.
              <a href="https://davidschiller.net/"><u>My website</u></a>
              showcases my personal and collaborative projects, reflecting my
              enthusiasm for engineering solutions that make a difference. Feel
              free to explore and reach out for any collaborative opportunities or
              engaging discussions in the realm of web and product development.
            </div>
          </div>
        </ReactiveCard>
      </div>
    </div>
    <div class="lg:flex gap-6 px-4 mt-20 lg:mt-16">
      <ReactiveCard class="lg:w-1/2 mb-8 lg:mb-0">
        <div>
          <img
            :src="photos.alisa.src"
            :srcset="photos.alisa.srcset"
            :sizes="photoSizes"
            alt="Alisa"
            loading="lazy"
            decoding="async"
            width="250"
            height="250"
            class="w-1/2 aspect-square object-cover mx-auto border-2 rounded-full"
          />
          <div class="text-center text-3xl mt-4">Alisa Alyabyeva</div>
          <div class="text-center text-2xl">Creative Designer</div>
          <div class="px-8 mt-4 text-center">
            As a Creative Designer with over a decade of immersive experience, I
            have cultivated a deep passion for transforming ideas into visual
            narratives. My career path has woven through the vibrant tapestry of
            digital media, branding, and user experience design, working with a
            spectrum of clients from dynamic startups to renowned global brands.
            My personal
            <a href="https://www.behance.net/aea9" target="_blank"
              ><u>portfolio</u>
            </a>
            is a testament to my versatility. I specialize in harnessing the power
            of design tools like Adobe Creative Suite, Figma, and InVision,
            blending creativity with technology to craft designs that resonate
            with audiences and stand out in a digital-first world. My approach is
            always user-centric, aiming to create designs that are not just
            visually stunning but also intuitively navigable and aligned with our
            clients' strategic goals.
          </div>
        </div>
      </ReactiveCard>
      
      <ReactiveCard class="lg:w-1/2">
        <div>
          <img
            :src="photos.aiden.src"
            :srcset="photos.aiden.srcset"
            :sizes="photoSizes"
            alt="Aiden"
            loading="lazy"
            decoding="async"
            width="250"
            height="250"
            class="w-1/2 aspect-square object-cover mx-auto border-2 rounded-full"
          />
          <div class="text-center text-3xl mt-4">Aiden Cullo</div>
          <div class="text-center text-2xl">Engineer</div>
          <div class="px-8 mt-4 text-center">
            As a Full Stack Engineer with our team, I bring a versatile skill set
            and a passion for developing seamless, efficient digital solutions.
            With a strong foundation in both front-end and back-end technologies,
            my expertise spans from crafting intuitive user interfaces to
            architecting robust server-side applications. I am adept in a range of
            programming languages and frameworks, including JavaScript, React,
            Node.js, Python, and Ruby on Rails, allowing me to tackle diverse
            challenges across the entire software development lifecycle. My
            projects often involve building scalable web applications, creating
            API integrations, and ensuring data security and performance
            optimization. I thrive on collaboration, consistently striving to
            align technical solutions with our team's vision and our clients'
            needs. My goal is to continue pushing the boundaries of web
            development, fostering innovation, and delivering high-quality,
            impactful software products.
          </div>
        </div>
      </ReactiveCard>
      <div class="hidden lg:w-1/2 mt-20 lg:mt-0">
        <img
          :src="photos.yuliya.src"
          :srcset="photos.yuliya.srcset"
          :sizes="photoSizes"
          alt="Yuliya"
          loading="lazy"
          decoding="async"
          width="250"
          height="250"
          class="w-1/2 aspect-square object-cover mx-auto border-2 rounded-full"
        />
        <div class="text-center text-3xl mt-4">Yuliya Klishch</div>
        <div class="text-center text-2xl">Product Designer</div>
        <div class="px-8 mt-4 text-center">
          Hello, I'm a product designer deeply fascinated by the intersection of
          human behavior and digital product design. I thrive on empathizing
          with users, transforming that understanding into meticulously crafted
          and innovative designs.
          <a href="https://yuliyaklishch.com/"><u>My background</u></a> in
          psychology, biotechnology, and education has sharpened my skills in
          collaboration, team building, and time management. Being part of this
          dynamic team is incredibly fulfilling for me. I am excited about the
          innovative work we do and how it pushes the boundaries of what's
          possible in product design. When I'm not busy creating intuitive
          prototypes, you'll find me immersed in illustration, cycling, or
          experimenting with new recipes in the kitchen. I believe that a great
          design is born out of keen observation and a deep understanding of
          people, and I bring this philosophy to every project I undertake,
          especially within this inspiring team environment.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineAsyncComponent } from "vue";
import ReactiveCard from "@/components/ReactiveCard.vue";
import { usePerformanceMonitor } from "@/composables/usePerformanceMonitor";
import vadim320 from "@/assets/team/vadim-320.webp";
import vadim640 from "@/assets/team/vadim-640.webp";
import david320 from "@/assets/team/david-320.webp";
import david640 from "@/assets/team/david-640.webp";
import alisa320 from "@/assets/team/alisa-320.webp";
import alisa640 from "@/assets/team/alisa-640.webp";
import aiden320 from "@/assets/team/aiden-320.webp";
import aiden460 from "@/assets/team/aiden-460.webp";
import yuliya320 from "@/assets/team/yuliya-320.webp";
import yuliya640 from "@/assets/team/yuliya-640.webp";
// async so apexcharts stays out of the entry bundle
const RadarChart = defineAsyncComponent(() =>
  import("@/components/charts/RadarChart.vue")
);

// Team photos are pre-resized WebP (originals were 600-760 KB PNGs on imgur).
const photo = (small, large, largeW = 640) => ({
  src: small,
  srcset: `${small} 320w, ${large} ${largeW}w`,
});
const photos = {
  vadim: photo(vadim320, vadim640),
  david: photo(david320, david640),
  alisa: photo(alisa320, alisa640),
  aiden: photo(aiden320, aiden460, 460),
  yuliya: photo(yuliya320, yuliya640),
};
// Image is w-1/2 of its card: cards are ~half the viewport at lg, full width below.
const photoSizes = "(min-width: 1024px) 25vw, 50vw";

// Dev-only: the monitor runs a permanent rAF loop, which visitors shouldn't pay for.
if (import.meta.env.DEV) usePerformanceMonitor("TeamSection");
</script>

<style scoped></style>
